const Homeproduct = () => {
  const destinations = [
    {
      name: "Maidan",
      image:
        "https://images.unsplash.com/photo-1558431382-27e303142255?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4NDk1NzN8MHwxfHNlYXJjaHw0fHxrb2xrYXRhfGVufDB8fHx8MTc3MDg4OTAwMnww&ixlib=rb-4.1.0&q=80&w=400",
    },
    {
      name: "Park Street",
      image:
        "https://images.unsplash.com/photo-1697200167302-e23861ead4d7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4NDk1NzN8MHwxfHNlYXJjaHw0fHxwYXJrJTIwc3RyZWV0JTIwa29sa2F0YXxlbnwwfHx8fDE3NzA5Njk4MzZ8MA&ixlib=rb-4.1.0&q=80&w=400",
    },
    {
      name: "Howrah",
      image:
        "https://images.unsplash.com/photo-1677307816181-1446ab18913e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4NDk1NzN8MHwxfHNlYXJjaHwxMHx8a29sa2F0YXxlbnwwfHx8fDE3NzA4ODkwMDJ8MA&ixlib=rb-4.1.0&q=80&w=400",
    },
    {
      name: "Saltlake",
      image:
        "https://www.cbre.co.in/resources/fileassets/IN-SMPL-380/5bf2ee66/1b54c514-1c9a-499d-9a62-d5f84741875d_watermark_Photo_2_large.jpg",
    },
    {
      name: "Rajarhat",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR3a6ZJvFLdjNDplcdr_u9owFlnU26T0JoXpg&s",
    },
    {
      name: "Lake Town",
      image:
        "https://images.unsplash.com/photo-1603813507806-0d311a6eecd1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4NDk1NzN8MHwxfHNlYXJjaHw1fHxrb2xrYXRhfGVufDB8fHx8MTc3MDg4OTAwMnww&ixlib=rb-4.1.0&q=80&w=400",
    },
  ];

  return (
    <section className="bg-[#f8f5f2] py-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-semibold text-gray-800">
            Top <span className="text-[#b76d68]">Destinations</span>
          </h2>
          <p className="text-gray-500 mt-2 font-outfit">
            Discover your perfect wedding destination
          </p>
          {/* Decorative Divider */}
          <div className="flex justify-center items-center gap-3 mt-6">
            <div className="w-10 h-[1px] bg-red-300"></div>
            <div className="w-2 h-2 bg-red-400 rounded-full"></div>
            <div className="w-10 h-[1px] bg-red-300"></div>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {destinations.map((item, index) => (
            <div
              key={index}
              className="relative rounded-2xl overflow-hidden shadow-lg group cursor-pointer"
            >
              {/* Image */}
              <img
                src={`${item.image}?auto=format&fit=crop&w=800&q=80`}
                alt={item.name}
                className="w-full h-[320px] object-cover group-hover:scale-105 transition duration-500"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition duration-300"></div>

              {/* Text Center */}
              <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-white">
                <h3 className="text-3xl font-semibold text-center ">
                  {item.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Homeproduct;
